import { Card } from '@buyerflo/ui/components/Card'
import Button from 'components/button'
import { SizableText, YStack } from 'tamagui'
import { CheckItem } from '../CheckItem'
import { useOnboarding } from '../OnboardingContext'

export default function XeroGuide() {
    const { progress, setCurrentStep, startStepTour } = useOnboarding()

    const xeroConnected = progress?.xeroConnected ?? false
    const xeroConfigured = progress?.xeroConfigured ?? false
    const allDone = progress?.xeroDone ?? false

    const buttonLabel = allDone
        ? undefined
        : xeroConnected
          ? 'Finish setting up'
          : 'Show me'

    return (
        <YStack gap="$4">
            <SizableText size="$6" fontWeight="700">
                Connect Xero
            </SizableText>
            <SizableText size="$3" color="$colorSoft">
                Connect your Xero account to automatically generate engagement and commission invoices when clients sign forms.
            </SizableText>

            <Card padding="$3" gap="$2">
                <CheckItem label="Connect Xero account" checked={xeroConnected} />
                <CheckItem label="Select engagement resource" checked={xeroConfigured} />
                <CheckItem label="Select commission resource" checked={xeroConfigured} />
            </Card>

            {!allDone && buttonLabel && (
                <Button
                    size="$4"
                    theme="primary"
                    onPress={() => startStepTour('xero')}
                >
                    {buttonLabel}
                </Button>
            )}

            {allDone && (
                <Button
                    size="$3"
                    variant="outlined"
                    onPress={() => setCurrentStep(2)}
                >
                    Next step
                </Button>
            )}
        </YStack>
    )
}
